import { useMutation } from 'react-query';
import { authFetchBlob } from '../../../../../../CommonUtils/authFetchBlob';
import { urlWithParams } from '../../../../../../CommonUtils/urlWithParams';
import { toast } from '../../../../../../CommonComponents/OPL/Toast/Toast';

interface DownloadAgreementParams {
  isFirm?: boolean;
  agreementId: string;
}

const downloadAgreement = ({ isFirm, agreementId }: DownloadAgreementParams) => {
  return authFetchBlob(
    urlWithParams(`/Adviser/Settings/${isFirm ? 'FirmAgreement' : 'MyAgreement'}`, {
      agreementId,
    }),
  );
};

export const useDownloadAgreementMutation = () => {
  return useMutation(downloadAgreement, {
    onError() {
      toast.error('There was an error downloading this file. Please try again later.');
    },
  });
};
